import { SHOW_POINT_LIST } from "../action/Action";

const initialState = {
    pointListData: [],
}

const pointListReducer = (state = initialState, action) => {
    switch (action?.type) {
        case SHOW_POINT_LIST:
            return {
                ...state,
                pointListData: action?.payload
            };
        default:
            return state;
    }
}

export default pointListReducer;